<template>
    <div class="pileEquipment">
        <!-- 标题 -->
        <div class="pileEquipment_title">
            <div class="pileEquipment_title_main">
                <span class="pileEquipment_eyebrow">STATION EQUIPMENT</span>
                <div class="pileEquipment_title_left">站点设备</div>
                <p>集中查看枪桩运行状态、输出参数、订单入口与场站基础信息。</p>
            </div>
            <div class="pileEquipment_title_side">
                <div class="pileEquipment_metrics">
                    <div class="pileEquipment_metric_card">
                        <span>设备列表</span>
                        <strong>{{ list.length || 0 }}</strong>
                    </div>
                    <div class="pileEquipment_metric_card">
                        <span>当前视图</span>
                        <strong>{{ type == 0 ? '枪桩' : '场站' }}</strong>
                    </div>
                </div>
                <div class="pileEquipment_title_right">
                    <div :class="['pileEquipment_title_right_info', type == 0 ? 'pileEquipment_title_right_btn' : '']"
                        @click="type = 0">枪桩设备</div>
                    <div :class="['pileEquipment_title_right_info', type == 1 ? 'pileEquipment_title_right_btn' : '']"
                        @click="getDetail">场站信息</div>
                </div>
            </div>
        </div>
        <!-- 枪桩设备 -->
        <div class="pileEquipment_content_gun" v-if="type == 0">
            <!-- 搜索框 -->
            <div class="search_box">
                <div class="pileEquipment_search">
                    <el-input placeholder="搜索枪编码 / 桩编码" v-model="code" clearable>
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </div>
                <button @click="search" class="public_saleWater_chaxun pulic_cursor">
                    查询
                </button>
            </div>
            <!-- 列表 -->
            <div class="pileEquipment_list">
                <el-row type="flex" class="row-bg" style="flex-wrap: wrap;">
                    <el-col :span="12" class="pileEquipment_list_item" v-for="(item, index) in list" :key="index">
                        <div class="pileEquipment_list_item_content">
                            <div class="grid-content bg-purple">
                                <div class="pileEquipment_item_content">
                                    <div class="pileEquipment_item_header">
                                        <div class="pileEquipment_item_header_left">
                                            <span>{{ item.ormtb602ca03 }}：{{ item.ormtb602ca00 }}</span>
                                            <el-tooltip class="item" effect="dark" content="点击查看告警信息记录"
                                                placement="top-start">
                                                <span class="el-icon-warning"
                                                    style="color: #e6a23c;margin-left: 12px;cursor: pointer;"
                                                    @click="getAlarmList(item)"></span>
                                            </el-tooltip>
                                        </div>
                                        <div class="pileEquipment_item_header_right" id="桩重启" v-shiroHiden="solelist"
                                            @click="pileRestart(item)">桩重启
                                        </div>
                                    </div>
                                    <div class="pileEquipment_item_body">
                                        <div class="pileEquipment_body_item" v-for="(it, idx) in item.ormtbGunDetailVos"
                                            :key="idx">
                                            <div class="pileEquipment_body_item_line">
                                                <div class="pileEquipment_body_line_left"
                                                    style="font-size: 18px;color: #6B7280;font-weight: 700;">{{
                                                        it.ormtb603ca07 }}</div>
                                                <div class="pileEquipment_body_dot"></div>
                                            </div>
                                            <div class="pileEquipment_body_item_line">
                                                <div class="pileEquipment_body_line_left">输出电流</div>
                                                <div class="pileEquipment_body_line_right">{{ it.exportElectricity ||
                                                    '--' }}</div>
                                            </div>
                                            <div class="pileEquipment_body_item_line">
                                                <div class="pileEquipment_body_line_left">输出电压</div>
                                                <div class="pileEquipment_body_line_right">{{ it.exportVoltage || '--'
                                                }}
                                                </div>
                                            </div>
                                            <div class="pileEquipment_body_item_line">
                                                <div class="pileEquipment_body_line_left">输出soc</div>
                                                <div class="pileEquipment_body_line_right">{{ it.soc || '--' }}</div>
                                            </div>
                                            <div class="pileEquipment_body_btn" id="订单" v-shiroHiden="solelist"
                                                @click="getOrderList(item.ormtb602ca00)">订单</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- 场站信息 -->
        <div class="pileEquipment_info" v-if="type == 1">
            <div class="pileEquipment_info_card pileEquipment_info_card_main">
                <div class="pileEquipment_info_item">
                    <span>充电场站名称</span>
                    <strong>{{ info.ormtb601ca00 || '--' }}</strong>
                </div>
                <div class="pileEquipment_info_item pileEquipment_info_item_full">
                    <span>详细地址</span>
                    <strong>{{ info.ormtb601ca01 || '--' }}</strong>
                </div>
                <div class="pileEquipment_info_item">
                    <span>桩数量</span>
                    <strong>{{ info.zsl || 0 }}</strong>
                </div>
                <div class="pileEquipment_info_item">
                    <span>总功率(Kw)</span>
                    <strong>{{ info.zgl || 0 }}</strong>
                </div>
                <div class="pileEquipment_info_item">
                    <span>营业状态</span>
                    <strong>{{ info.ormtb601ca04 == 1 ? '运营' : '下架' }}</strong>
                </div>
                <div class="pileEquipment_info_item pileEquipment_info_item_full">
                    <span>备注</span>
                    <strong>{{ info.ormtb601ca08 || '--' }}</strong>
                </div>
            </div>
            <div class="pileEquipment_info_card pileEquipment_info_card_side">
                <div class="pileEquipment_info_item">
                    <span>可用数量</span>
                    <strong>{{ info.kysl || 0 }}</strong>
                </div>
                <div class="pileEquipment_info_item">
                    <span>站点电话</span>
                    <strong>{{ info.ormtb601ca05 || '--' }}</strong>
                </div>
                <div class="pileEquipment_info_item pileEquipment_info_item_full">
                    <span>营业时间</span>
                    <strong>{{ info.ormtb601ca07 || '--' }}</strong>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            code: '',
            type: 0,
            list: [],
            info: {},
            solelist: []
        }
    },
    created() {
        var list = ''
        list = this.$store.state.solelist
        var path = this.$route.path
        // 赋值，缓存销毁
        this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
        this.userobj = this.$store.state.uobj
        this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表
        this.type = 0;
        this.code = '';
        this.getList();
    },
    methods: {
        // 获取列表
        getList() {
            this.axios.post('/orm/ormtb602/select602GunInfo', {
                key: this.code,
                ormtb601id: '1'
            }).then(res => {
                if (res.data.code == 200) {
                    this.list = res.data.data;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
            })
        },
        // 搜索
        search() {
            this.getList();
        },
        //站点详情
        getDetail() {
            this.type = 1;
            this.getStationInfo();
        },
        // 跳转订单
        getOrderList(pileCode) {
            let tabList = this.$store.state.tablist
            const tabIndex = tabList.findIndex(
                item => item.PERTB001CA05 === 'Home:chargingOrder'
            )
            if (tabIndex !== -1) {
                tabList.splice(tabIndex, 1) //移除已存在充电订单
            }
            let path = `/Home/chargingOrder?pileCode=${pileCode}`
            let resitem = {
                PERTB001CA00: '充电订单',
                PERTB001CA03: `${path}`,
                PERTB001CA04: '1',
                PERTB001CA05: 'Home:chargingOrder',
                PERTB001CB00: 'ALL',
            }

            var str = JSON.stringify(tabList)
            var index = str.indexOf('/Home/chargingOrder')
            if (index == -1) {
                var Stablsit = this.$store.state.tablist.slice()
                Stablsit.push(resitem)
                this.$store.commit('upEditableTabs', Stablsit)
            }
            this.$store.commit('setHistTabsValue', path)
            this.$router.push(this.$store.state.setHistTabsValue)
        },
        // 站详情
        getStationInfo() {
            this.axios.post('/orm/ormtb601/ormtb601Detail', {
                ormtb601id: '1'
            }).then(res => {
                if (res.data.code == 200) {
                    this.info = res.data.data;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
            })
        },
        // 桩重启
        pileRestart(item) {
            this.$confirm(`确定要重启${item.ormtb602ca03}吗?`, '重启确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.axios.post('/orm/ormtb602/restart', {
                    pileCode: item.ormtb602ca00
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            type: 'success',
                            message: res.data.message
                        });
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            })
        },
        // 查看告警信息
        getAlarmList(item) {
            let tabList = this.$store.state.tablist
            const tabIndex = tabList.findIndex(
                item => item.PERTB001CA05 === 'Home:alarmInformation'
            )
            if (tabIndex !== -1) {
                tabList.splice(tabIndex, 1) //移除已存在
            }
            let path = `/Home/alarmInformation?stationId=1&pileCode=${item.ormtb602ca00}`
            let resitem = {
                PERTB001CA00: '告警信息',
                PERTB001CA03: `${path}`,
                PERTB001CA04: '1',
                PERTB001CA05: 'Home:alarmInformation',
                PERTB001CB00: 'ALL',
            }

            var str = JSON.stringify(tabList)
            var index = str.indexOf('/Home/alarmInformation')
            if (index == -1) {
                var Stablsit = this.$store.state.tablist.slice()
                Stablsit.push(resitem)
                this.$store.commit('upEditableTabs', Stablsit)
            }
            this.$store.commit('setHistTabsValue', path)
            this.$router.push(this.$store.state.setHistTabsValue)
        },
    }
}
</script>
<style scoped>
.pileEquipment {
    min-height: 100%;
    padding: 18px;
    background:
        radial-gradient(circle at 12% 8%, rgba(25, 159, 255, 0.12) 0, rgba(25, 159, 255, 0) 28%),
        linear-gradient(180deg, #f7fbff 0%, #edf5fb 100%);
    box-sizing: border-box;
    color: #25384d;
}

.pileEquipment_title {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    gap: 22px;
    padding: 24px;
    border: 1px solid rgba(188, 222, 236, 0.95);
    border-radius: 22px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.94) 0%, rgba(242, 251, 255, 0.94) 54%, rgba(238, 248, 244, 0.94) 100%);
    box-shadow: 0 16px 42px rgba(26, 99, 134, 0.11);
    box-sizing: border-box;
    overflow: hidden;
}

.pileEquipment_title::after {
    content: '';
    position: absolute;
    right: -54px;
    top: -72px;
    width: 210px;
    height: 210px;
    border-radius: 50%;
    background: rgba(25, 159, 255, 0.10);
}

.pileEquipment_title_main,
.pileEquipment_title_side {
    position: relative;
    z-index: 1;
}

.pileEquipment_title_main {
    min-width: 0;
}

.pileEquipment_eyebrow {
    display: inline-flex;
    align-items: center;
    margin-bottom: 8px;
    padding: 4px 10px;
    border-radius: 999px;
    background: rgba(25, 159, 255, 0.12);
    color: #1473b3;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 1.2px;
}

.pileEquipment_title_left {
    color: #17324d;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 1px;
}

.pileEquipment_title_main p {
    margin: 8px 0 0;
    color: #60758a;
    font-size: 13px;
    line-height: 1.6;
}

.pileEquipment_title_side {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    flex-shrink: 0;
}

.pileEquipment_metrics {
    display: flex;
    gap: 12px;
}

.pileEquipment_metric_card {
    min-width: 92px;
    padding: 12px 14px;
    border: 1px solid rgba(203, 226, 236, 0.92);
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.76);
    box-shadow: 0 8px 20px rgba(26, 99, 134, 0.08);
    text-align: center;
    box-sizing: border-box;
}

.pileEquipment_metric_card span {
    display: block;
    color: #6d8194;
    font-size: 12px;
}

.pileEquipment_metric_card strong {
    display: block;
    margin-top: 6px;
    color: #1473b3;
    font-size: 20px;
    line-height: 1;
}

.pileEquipment_title_right {
    display: flex;
    gap: 12px;
}

.pileEquipment_title_right_btn {
    border-color: transparent !important;
    background: linear-gradient(180deg, #4aaee8 0%, #199fff 100%) !important;
    color: #fff !important;
    box-shadow: 0 8px 18px rgba(25, 159, 255, 0.24);
}

.pileEquipment_title_right_info {
    min-width: 92px;
    height: 34px;
    padding: 0 14px;
    border: 1px solid rgba(203, 226, 236, 0.92);
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.86);
    color: #60758a;
    text-align: center;
    line-height: 34px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    box-sizing: border-box;
    transition: all 0.2s ease;
}

.pileEquipment_title_right_info:hover {
    border-color: rgba(25, 159, 255, 0.45);
    color: #1473b3;
}

.pileEquipment_content_gun {
    margin-top: 18px;
}

.search_box {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 18px 20px;
    border: 1px solid rgba(216, 232, 238, 0.96);
    border-radius: 18px;
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
    box-shadow: 0 12px 28px rgba(26, 99, 134, 0.08);
    box-sizing: border-box;
}

.pileEquipment_search {
    width: 320px;
}

::v-deep .pileEquipment_search .el-input__inner {
    height: 40px;
    border-color: rgba(203, 226, 236, 0.96);
    border-radius: 12px;
    background: #f8fcff;
    color: #25384d;
}

::v-deep .pileEquipment_search .el-input__inner:focus {
    border-color: #199fff;
    box-shadow: 0 0 0 3px rgba(25, 159, 255, 0.10);
}

.public_saleWater_chaxun {
    min-width: 84px;
    height: 40px;
    padding: 0 18px;
    border: none;
    border-radius: 12px;
    background: linear-gradient(180deg, #4aaee8 0%, #199fff 100%);
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    line-height: 40px;
    box-shadow: 0 8px 18px rgba(25, 159, 255, 0.24);
    cursor: pointer;
}

.public_saleWater_chaxun:hover {
    background: linear-gradient(180deg, #5bb8ee 0%, #148adf 100%);
}

.pileEquipment_list {
    margin-top: 18px;
}

.pileEquipment_list_item {
    padding: 10px;
    box-sizing: border-box;
}

.pileEquipment_list_item:nth-child(odd) {
    padding-left: 0;
}

.pileEquipment_list_item:nth-child(even) {
    padding-right: 0;
}

.pileEquipment_list_item_content {
    height: 100%;
    padding: 0;
    border: 1px solid rgba(216, 232, 238, 0.96);
    border-radius: 20px;
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
    box-shadow: 0 14px 34px rgba(26, 99, 134, 0.09);
    box-sizing: border-box;
    overflow: hidden;
}

.pileEquipment_item_content {
    height: 100%;
}

.pileEquipment_item_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    min-height: 72px;
    padding: 18px 20px;
    border-bottom: 1px solid rgba(216, 232, 238, 0.95);
    background: linear-gradient(180deg, #ffffff 0%, #f8fcff 100%);
    box-sizing: border-box;
}

.pileEquipment_item_header_left {
    display: flex;
    align-items: center;
    min-width: 0;
    color: #17324d;
    font-size: 18px;
    font-weight: 700;
}

.pileEquipment_item_header_left span:first-child {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.pileEquipment_item_header_left .el-icon-warning {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(230, 162, 60, 0.12);
    text-align: center;
    line-height: 32px;
    font-size: 18px;
}

.pileEquipment_item_header_right {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 78px;
    height: 34px;
    padding: 0 14px;
    border: 1px solid rgba(245, 108, 108, 0.24);
    border-radius: 999px;
    background: rgba(245, 108, 108, 0.08);
    color: #f56c6c;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    box-sizing: border-box;
}

.pileEquipment_item_header_right:hover {
    background: rgba(245, 108, 108, 0.14);
}

.pileEquipment_item_body {
    display: flex;
    padding: 18px 20px 20px;
    box-sizing: border-box;
}

.pileEquipment_body_item {
    width: 50%;
    padding: 0 18px 0 0;
    border-right: 1px solid rgba(216, 232, 238, 0.95);
    box-sizing: border-box;
}

.pileEquipment_body_item:nth-child(even) {
    padding: 0 0 0 18px;
    border-right: none;
}

.pileEquipment_body_item_line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 14px;
    min-height: 34px;
    padding: 6px 0;
    box-sizing: border-box;
}

.pileEquipment_body_line_left,
.pileEquipment_body_line_right {
    color: #6b7e90;
    font-size: 14px;
}

.pileEquipment_body_line_right {
    color: #17324d;
    font-weight: 700;
}

.pileEquipment_body_dot {
    width: 10px;
    height: 10px;
    border: 3px solid rgba(14, 159, 110, 0.14);
    border-radius: 50%;
    background: #0e9f6e;
    box-sizing: content-box;
}

.pileEquipment_body_btn {
    width: 100%;
    height: 36px;
    margin-top: 12px;
    border: 1px solid rgba(25, 159, 255, 0.28);
    border-radius: 12px;
    background: linear-gradient(135deg, #ffffff 0%, #eef8ff 100%);
    color: #1473b3;
    text-align: center;
    line-height: 36px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    box-sizing: border-box;
}

.pileEquipment_body_btn:hover {
    border-color: rgba(25, 159, 255, 0.48);
    color: #199fff;
    box-shadow: 0 8px 18px rgba(25, 159, 255, 0.12);
}

.pileEquipment_info {
    display: grid;
    grid-template-columns: minmax(0, 1.5fr) minmax(320px, 0.8fr);
    gap: 18px;
    margin-top: 18px;
}

.pileEquipment_info_card {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px;
    padding: 22px;
    border: 1px solid rgba(216, 232, 238, 0.96);
    border-radius: 20px;
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
    box-shadow: 0 14px 34px rgba(26, 99, 134, 0.09);
    box-sizing: border-box;
}

.pileEquipment_info_card_side {
    grid-template-columns: 1fr;
}

.pileEquipment_info_item {
    position: relative;
    min-height: 86px;
    padding: 18px 20px;
    border: 1px solid rgba(216, 232, 238, 0.95);
    border-radius: 16px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fcff 100%);
    box-shadow: 0 8px 18px rgba(26, 99, 134, 0.05);
    box-sizing: border-box;
    overflow: hidden;
}

.pileEquipment_info_item::after {
    content: '';
    position: absolute;
    right: -26px;
    bottom: -34px;
    width: 88px;
    height: 88px;
    border-radius: 50%;
    background: rgba(25, 159, 255, 0.06);
}

.pileEquipment_info_item_full {
    grid-column: 1 / -1;
}

.pileEquipment_info_item span {
    position: relative;
    z-index: 1;
    display: block;
    margin-bottom: 10px;
    color: #6b7e90;
    font-size: 13px;
    line-height: 1;
}

.pileEquipment_info_item strong {
    position: relative;
    z-index: 1;
    display: block;
    color: #17324d;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.5;
    word-break: break-all;
}

@media screen and (max-width: 1100px) {
    .pileEquipment_title {
        align-items: flex-start;
        flex-direction: column;
    }

    .pileEquipment_title_side {
        align-items: flex-start;
        width: 100%;
    }

    .pileEquipment_metrics,
    .pileEquipment_title_right {
        flex-wrap: wrap;
    }

    .pileEquipment_list_item {
        padding-right: 0;
        padding-left: 0;
    }

    .pileEquipment_list_item.el-col-12 {
        width: 100%;
    }

    .pileEquipment_info {
        grid-template-columns: 1fr;
    }
}

@media screen and (max-width: 760px) {
    .search_box,
    .pileEquipment_item_body {
        flex-direction: column;
        align-items: stretch;
    }

    .pileEquipment_search {
        width: 100%;
    }

    .pileEquipment_body_item,
    .pileEquipment_body_item:nth-child(even) {
        width: 100%;
        padding: 0;
        border-right: none;
    }

    .pileEquipment_body_item + .pileEquipment_body_item {
        margin-top: 18px;
        padding-top: 18px;
        border-top: 1px solid rgba(216, 232, 238, 0.95);
    }

    .pileEquipment_info_card {
        grid-template-columns: 1fr;
    }
}
</style>